var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.793945,
    y: 0.905273,
    width: 32.8523,
    height: 23.1899,
    rx: 2.89873,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.643 18.7133C25.2615 18.7133 28.1948 15.8149 28.1948 12.2395C28.1948 8.66406 25.2615 5.76562 21.643 5.76562C20.0214 5.76562 18.5373 6.34777 17.3933 7.3121C16.2492 6.34782 14.7652 5.76571 13.1436 5.76571C9.52514 5.76571 6.5918 8.66415 6.5918 12.2396C6.5918 15.815 9.52514 18.7134 13.1436 18.7134C14.7653 18.7134 16.2493 18.1312 17.3934 17.1669C18.5374 18.1312 20.0214 18.7133 21.643 18.7133Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3936 17.1669C18.8023 15.9794 19.6956 14.2125 19.6956 12.2395C19.6956 10.2664 18.8023 8.49949 17.3936 7.31206C18.5376 6.34775 20.0217 5.76562 21.6433 5.76562C25.2618 5.76562 28.1951 8.66406 28.1951 12.2395C28.1951 15.8149 25.2618 18.7133 21.6433 18.7133C20.0217 18.7133 18.5376 18.1312 17.3936 17.1669Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3939 17.1673C18.8026 15.9799 19.6959 14.213 19.6959 12.2399C19.6959 10.2668 18.8026 8.49992 17.3939 7.3125C15.9851 8.49992 15.0918 10.2668 15.0918 12.2399C15.0918 14.213 15.9851 15.9799 17.3939 17.1673Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.cf77b4c74f0f3a2a85b4c0a7ef537efe.svg";
export { ForwardRef as ReactComponent };